import { Injectable } from '@angular/core';
import { UrlSerializer } from 'ionic-angular';
import { normalizeLinks } from 'ionic-angular/navigation/url-serializer';
import _ from 'lodash';
//Pages
// import { DynamicPage } from '../pages/dynamic-page/dynamic-page';


@Injectable()
export class PageRef {
  public constructor( public urlSerializer: UrlSerializer){}

  // public static get(name): any {
  //   return DynamicPage;
  // }
  public addCfgLinks(cfgLinks): any{
    let isMobile = (<any>document.getElementById('appMode')).value === 'mobile';
    if(!isMobile){
      cfgLinks = _.map(cfgLinks, function(item:any){
        item.component = item.fullComponent;
        delete item.fullComponent;
        return item;
      });
    }
    let links = normalizeLinks(cfgLinks);
    Array.prototype.push.apply(this.urlSerializer.links, links);
  }
  public get(name): any { 
	  var links = this.urlSerializer.links;
    let link = _.find(links,function(l: any){
      return l.segment == name || l.alias == name;
    });
    if(link){
      return link.component;
    }
    else {
      // return DynamicPage;
    }

  }
}




// WEBPACK FOOTER //
// ./src/core/page-ref.ts